import { render, staticRenderFns } from "./AlertDashboard.vue?vue&type=template&id=6692743d&scoped=true&"
import script from "./AlertDashboard.vue?vue&type=script&lang=ts&"
export * from "./AlertDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDashboard.vue?vue&type=style&index=0&id=6692743d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6692743d",
  null
  
)

export default component.exports